import { render, staticRenderFns } from "./SponserHomeTwo.vue?vue&type=template&id=6b733a45"
import script from "./SponserHomeTwo.vue?vue&type=script&lang=js"
export * from "./SponserHomeTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports